document.documentElement.classList.add('js');
// Production safety: external links opened in a new tab should not retain opener access.
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('a[target="_blank"]').forEach(function (a) {
    var rel = (a.getAttribute('rel') || '').split(/\s+/).filter(Boolean);
    if (!rel.includes('noopener')) rel.push('noopener');
    a.setAttribute('rel', rel.join(' '));
  });
});
